var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0713 9.4944C12.9919 6.78231 12.3496 3.02685 9.63747 1.10668C6.92537 -0.813486 3.16992 -0.171595 1.24975 2.54096C-0.67042 5.25305 -0.0285284 9.00805 2.68403 10.9282C4.61979 12.2987 7.1791 12.4042 9.22086 11.1985L13.6572 15.6082C14.1362 16.1124 14.9332 16.1326 15.4374 15.6536C15.9417 15.1751 15.9619 14.3781 15.4833 13.8739C15.4682 13.8578 15.4535 13.8431 15.4374 13.828L11.0713 9.4944ZM6.15685 9.9055C4.01369 9.90596 2.27613 8.16978 2.27476 6.02663C2.2743 3.88347 4.01048 2.14591 6.15409 2.145C8.2945 2.14408 10.0311 3.87751 10.0353 6.01791C10.0389 8.16152 8.30367 9.90183 6.1596 9.9055C6.15868 9.9055 6.15822 9.9055 6.15685 9.9055Z",
    fill: "#969EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7216b7dcf266af8dcae13f6114e9576c.svg";
export { ForwardRef as ReactComponent };